/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IShiftEntity } from "sh-models";

import { CrossLocationShiftCardProps } from "../../../shift/shiftCards/CrossLocationShift/CrossLocationShiftCardProps";
import ShiftUtils from "../../../../utility/ShiftUtils";

/**
 * Retrieves the shift props.
 * @param shift The shift details.
 * @returns The props for the shift.
 */
export const getShiftProps = (shift: IShiftEntity): CrossLocationShiftCardProps|undefined => {
    if (!shift) {
        return undefined;
    }

    // TODO (CLM): Implement cross location icon - doShowCrossLocationIcon
    return {
        shift: shift,
        teamId: ShiftUtils.isCrossLocationShift(shift) ? shift.teamId : undefined
    };
};
